import React from 'react';
import { ThemeProvider as StyledComponentsThemeProvider, useTheme } from 'styled-components';
import { getTokens } from './theme/index.js';
export const ThemeProvider = ({ children, theme }) => {
    const parentTheme = useTheme();
    const effectiveTheme = {
        ...parentTheme,
        ...theme
    };
    const tokens = getTokens(theme?.name ?? parentTheme?.name);
    return (React.createElement(StyledComponentsThemeProvider, { theme: { ...effectiveTheme, ...tokens } }, children));
};
//# sourceMappingURL=index.js.map